import React, {useRef} from 'react'
import {FaEllipsisH} from 'react-icons/fa';
import { Dropdown } from 'react-bootstrap';


const FeedCardThreeDotsDropdown = ({contentDiv}) => {
    const dropdownRef = useRef()
  return (
    <>
        <button className='three-dots-button' onClick={() => dropdownRef.current.click()}>
            <FaEllipsisH className='feed-menu'/>
        </button>
    
        <Dropdown className='hidden-dropdown'>
            <Dropdown.Toggle variant="success" id="dropdown-basic" className='hidden-dropdown-button' ref={dropdownRef}></Dropdown.Toggle>

            <Dropdown.Menu className='dropdown-menu'>
                {contentDiv}
            </Dropdown.Menu>
        </Dropdown>
    </>
  )
}

export default FeedCardThreeDotsDropdown